<template>
    <div>
        <p v-loading="loading" id="porcent" v-if="porcent == 100">{{ porcent }}% Completado</p>
        <p v-loading="loading" id="porcent" v-else>{{ porcent }}% Avance</p>
    </div>
</template>

<script>
import { getLecturesByCourse } from '@/requests/lectures'
import { getInscriptionByCourse } from '@/requests/inscriptions'
import { getCourse } from '@/requests/courses'
export default {
    props: [ 'courseId' ],
    data() {
        return {
            totalLectures: 0,
            totalAproved: 0,
            loading: false,
            porcent: 0,

        }
    },
    mounted() {
        this.loading = true
        getLecturesByCourse({ id: this.courseId })
        .then((respuesta)=>{
            this.totalLectures = respuesta.count
            var lectures = respuesta.items

            getCourse({ id: this.courseId })
            .then((course)=>{
                // console.log('course', course)

                getInscriptionByCourse({ userId: this.$session.get('userId'), courseId: this.courseId })
                .then((resp)=>{
                    let inscriptions = resp.items[0]
                    // console.log('ins', inscriptions)
                    let cont = 0
                    var count = 0

                    if(!inscriptions){
                        this.porcent = 0
                    }
                    else if(inscriptions.isApproved){
                        this.porcent = 100
                    }else{
                        for (let i = 0; i < inscriptions.results.length; i++) {
                            if(inscriptions.results[i]){
                                cont++
                            }
                            
                        }
                        for (let a = 0; a < respuesta.items.length; a++) {
                            if(respuesta.items[a].type == 'exam'){
                                for (let e = 0; e < inscriptions.examTries.length; e++) {
                                    if(inscriptions.examTries[e] == respuesta.items[a]._id){
                                        count++
                                    }
                                    
                                }
                            }
                            
                        }

                        this.porcent = Math.round(cont/this.totalLectures * 100)
                        if(count == course.maxExamRetries){
                           this.porcent = 100
                        }
                        
                        
                        
                    }
                    this.loading = false
                })
            })
        })
    }
}
</script>

<style>
    #porcent{
        margin: 5px 0px;
        color: #0056A8;
    }
</style>



// WEBPACK FOOTER //
// src/components/courses/completePorcent.vue